import { ACTIONS_MAP_MARKETS as C_ACTION } from '../actions/mapMarkets';

export const mapMarkets = (state = {}, action) => {
  switch (action.type) {
    case C_ACTION.ADD_MARKETS_PRODUCTS: {
      const market = [action.market];

      return { ...state, [market]: { ...state[market], ...action.data } };
    }
    case C_ACTION.REMOVE_MARKET_PRODUCT: {
      return { ozon: {}, ozon2: {}, wb: {}, goods: {}, beru: {}, beru2: {}, bWhite: {} };
    }
    case C_ACTION.CHANGE_MARKET_PRODUCT: {
      const market = [action.market];
      const product = market[action.sku];

      console.log({ [action.sku]: { ...product, ...action.data } });
      return { ...state, [market]: { ...state[market], [action.sku]: { ...product, ...action.data } } };
    }
    default:
      return state;
  }
};
